module.exports = __webpack_public_path__ + "98521795c76a212ee0c30353a3e0a31d.png";